import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import useGenericCall from '../../hooks/useGenericCall';
import { useOnchainAccount } from '../../hooks/useOnchain';
import ClaimAirdropModal from '../InteractionModal/ClaimAirdropModal';

/**
 * Sets up a component for the application's wallet section, when the wallet is connected.
 */
 export function ClaimAirdrop() {
  const [showClaimAirdropModal, toggleClaimAirdropModal] = useState(false);

  const airdropDataIbex = useGenericCall(useOnchainAccount(), r => r.getIbexAirdropData());
  const airdropDataIbex2 = useGenericCall(useOnchainAccount(), r => r.getIbex2AirdropData());
  const airdropDataEth = useGenericCall(useOnchainAccount(), r => r.getEthAirdropData());

  if (
    (!airdropDataIbex || !airdropDataIbex.amount) && 
    (!airdropDataIbex2 || !airdropDataIbex2.amount) && 
    (!airdropDataEth || !airdropDataEth.amount)
  ) return (null);

  return (<>
    <Button className="claim-button" onClick={() => toggleClaimAirdropModal(true)}>
      Claim Airdrop
    </Button>
    <ClaimAirdropModal 
      show={showClaimAirdropModal} 
      toggleShow={toggleClaimAirdropModal}
    />
  </>);
 }

/*export function ClaimAirdrop() {
  const router = useImpermaxOnchain();
  const airdropData = useGenericCall(useOnchainAccount(), r => r.getIbexAirdropData());
  const [claimAirdropState, claimAirdrop] = useClaimAirdrop(airdropData, router ? router.contractsHelper.merkleDistributorIbex : null);

  if (!airdropData || !airdropData.amount) return (null);

  return (<>
    <Button className="claim-button" onClick={claimAirdropState == ButtonState.Ready ? claimAirdrop : null}>
      Claim { formatAmount(parseFloat(airdropData.amount.toString()) / 1e18) } IBEX
    </Button>
  </>);
}*/